<template>
  <el-dialog
    title="修改微信号"
    :visible.sync="dialogVisible"
    width="500px"
    append-to-body
    :before-close="handleCancel"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="微信号" prop="wx">
        <el-input v-model="form.wx" placeholder="请输入微信号" :maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="微信二维码" prop="wxCode">
        <div class="qrcode-upload-area">
          <div class="qrcode-preview" v-if="form.wxCode">
            <img :src="form.wxCode" class="qrcode-img" />
            <div class="qrcode-actions">
              <el-button type="text" @click="handleReUpload">重新上传</el-button>
              <el-button type="text" class="del-btn" @click="handleRemoveQrCode">删除</el-button>
            </div>
          </div>
          <el-upload
            v-else
            ref="upload"
            class="qrcode-uploader"
            action="#"
            accept=".jpg,.jpeg,.png"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleFileChange"
          >
            <div class="upload-placeholder">
              <i class="el-icon-plus"></i>
              <span class="upload-text">上传我的二维码图片</span>
            </div>
          </el-upload>
          <div class="upload-tips">仅支持jpg、png格式，大小不超过5MB</div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" :loading="saving" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import OSSClient from '@/components/Uploads/OSS-client';
import { getEditWxInfo } from '@servers/commodity/index';

export default {
  data() {
    return {
      dialogVisible: false,
      saving: false,
      form: {
        wx: '',
        wxCode: ''
      },
      rules: {
        wx: [
          { required: true, message: '请输入微信号', trigger: 'blur' },
          { max: 20, message: '微信号不超过20个字符', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    method_open(wx, wxCode) {
      this.form.wx = wx || '';
      this.form.wxCode = wxCode || '';
      this.dialogVisible = true;
    },
    handleFileChange(file) {
      const rawFile = file.raw;
      // 校验格式
      const suffix = rawFile.name.substring(rawFile.name.lastIndexOf('.')).toLowerCase();
      if (!['.jpg', '.jpeg', '.png'].includes(suffix)) {
        this.$message.error('图片格式不正确，仅支持jpg、png格式');
        return;
      }
      // 校验大小
      if (rawFile.size > 5 * 1024 * 1024) {
        this.$message.error('图片过大，请重新选择图片上传');
        return;
      }
      this.uploadToOSS(rawFile);
    },
    uploadToOSS(file) {
      const userInfo = this.$store.getters.userInfo || {};
      const companyId = userInfo.companyId || 'default';
      const fileName = `${Date.now()}_${file.name}`;
      const path = `scm/${companyId}/wxCode/${fileName}`;
      OSSClient.getInstance().singleUpload(path, file, {
        success: (res) => {
          if (res && res.url) {
            this.form.wxCode = res.url;
          }
        },
        fail: () => {
          this.$message.error('图片上传失败，请重试');
        }
      });
    },
    handleReUpload() {
      // 清除当前图片后触发上传
      this.form.wxCode = '';
      this.$nextTick(() => {
        this.$refs.upload?.$refs?.['input-file']?.click();
      });
    },
    handleRemoveQrCode() {
      this.form.wxCode = '';
    },
    async handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const res = await getEditWxInfo({
            wx: this.form.wx,
            wxCode: this.form.wxCode
          });
          if (res) {
            this.$message.success('修改成功');
            this.$emit('success', { wx: this.form.wx, wxCode: this.form.wxCode });
            this.handleCancel();
          }
        } finally {
          this.saving = false;
        }
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$refs.form?.resetFields();
      this.form.wxCode = '';
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode-upload-area {
  .qrcode-preview {
    display: inline-block;
    text-align: center;
    .qrcode-img {
      width: 150px;
      height: 150px;
      object-fit: contain;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      display: block;
      margin-bottom: 8px;
    }
    .qrcode-actions {
      .del-btn {
        color: #f56c6c;
      }
    }
  }
  .qrcode-uploader {
    .upload-placeholder {
      width: 150px;
      height: 150px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        border-color: #409eff;
      }
      i {
        font-size: 28px;
        color: #8c939d;
      }
      .upload-text {
        font-size: 12px;
        color: #8c939d;
        margin-top: 8px;
      }
    }
  }
  .upload-tips {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
}
</style>
